import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

class CompaniesService extends BaseCollectionService {
  constructor() {
    super("companies");
  }

  async getOneCompany(query: { _id?: string; companyNumber?: string }) {
    const path = `companies`;
    return await this.request(
      {
        method: "get",
        url: path,
        params: query
      },
      { useToken: "access" }
    );
  }

  async deleteBulk(companyIds: string[]): Promise<ResponseWrapper> {
    const path = `companies/bulk-delete`;
    return await this.request(
      { method: "put", url: path, data: { companyIds } },
      { useToken: "access" }
    );
  }

  async restoreBulk(companyIds: string[]): Promise<ResponseWrapper> {
    const path = `companies/bulk-restore`;
    return await this.request(
      { method: "put", url: path, data: { companyIds } },
      { useToken: "access" }
    );
  }

  async permanentDelete(companyId: string): Promise<ResponseWrapper> {
    const path = `companies/${companyId}/permanent`;
    return await this.request(
      { method: "delete", url: path },
      { useToken: "access" }
    );
  }

  async getReferenceCounts(companyId: string): Promise<ResponseWrapper> {
    const path = `companies/${companyId}/reference-counts`;
    return await this.request(
      { method: "get", url: path },
      { useToken: "access" }
    );
  }
}

export default new CompaniesService();
